import { useQuery } from "@tanstack/react-query";
import * as api from "./request";

export function useGetComplianceItemStatus(payload: any, enabled = true) {
  const { data, isFetching, refetch } = useQuery(
    ["complianceItemStatus", payload],
    async () =>
      await api.post(
        `/api/v1/vendor_location_audits/audit_status_counts`,
        payload || {}
      ),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      enabled,
    }
  );

  const responseData = (data || { data: {} }).data;

  return {
    complianceItemStatus: responseData || null,
    isFetching,
    refetch,
  };
}

export function useGetVendorPerformanceMatrix(payload: any, enabled = true) {
  const { data, isFetching, refetch } = useQuery(
    ["vendorPerformanceMatrix", payload],
    async () =>
      await api.post(
        `/api/v1/vendor_location_audits/vendor_performance_matrix`,
        payload || {}
      ),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      enabled,
      keepPreviousData: true,
      staleTime: 30000,
    }
  );

  const responseData = (data || { data: {} }).data;

  return {
    performanceMatrix: (responseData && responseData.data) || responseData || null,
    isFetching,
    refetch,
  };
}

export function useGetRecentAuditReports(payload: any, enabled = true) {
  const { data, isFetching, refetch } = useQuery(
    ["recentAuditReports", payload],
    async () =>
      await api.post(
        `/api/v1/vendor_location_audits/recent_audit_reports`,
        payload || {}
      ),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      enabled,
      keepPreviousData: true,
      staleTime: 30000,
    }
  );

  const responseData = (data || { data: {} }).data;

  return {
    recentAuditReports: responseData || null,
    isFetching,
    refetch,
  };
}
